import { Action } from "redux"

import { removeTile, reorderTiles } from "../../util/Grid"
import * as actions from "./actions"
import { ICoverPage } from "./index"

export const initialState: ICoverPage = {
    workspaceId: 0,
    workspaceScreenLabel: "",
    isLoading: false,
    content: {
        children: [],
        contentLabel: "",
        filter: "",
        hasMore: false,
        isLoading: false,
        isLoadingMore: false,
        limit: 10,
        noWorkspaceContentFoundFilteredLabel: "",
        noWorkspaceContentFoundLabel: "",
        noWorkspaceContentMessage: "",
        offset: 0,
    },
    grid: {
        id: -1,
        tiles: [],
    },
}

const ACTION_HANDLERS: {
    [action: string]: (state: ICoverPage, props: Action) => ICoverPage
} = {
    [actions.INITIALIZE]: (
        state,
        {
            workspaceId,
            workspaceScreenLabel,
            noWorkspaceContentFoundLabel,
            noWorkspaceContentFoundFilteredLabel,
            contentLabel,
        }: actions.Initialize,
    ): ICoverPage => ({
        ...state,
        workspaceId: workspaceId,
        workspaceScreenLabel: workspaceScreenLabel,
        content: {
            ...state.content,
            noWorkspaceContentFoundLabel,
            noWorkspaceContentFoundFilteredLabel,
            contentLabel,
        },
    }),

    [actions.REQUEST_WORKSPACE_CONTENT]: (
        state,
        { filter, offset, limit }: actions.RequestWorkspaceContent,
    ): ICoverPage => ({
        ...state,
        content: {
            ...state.content,
            filter,
            offset,
            limit,
            isLoading: true,
            isLoadingMore: filter === state.content.filter,
        },
    }),

    [actions.RECEIVE_WORKSPACE_CONTENT]: (
        state,
        { children, hasMore }: actions.ReceiveWorkspaceContent,
    ): ICoverPage => ({
        ...state,
        content: {
            ...state.content,
            children: state.content.isLoadingMore
                ? state.content.children?.concat(...children)
                : children,
            hasMore,
            isLoading: false,
            isLoadingMore: false,
            noWorkspaceContentMessage:
                children.length === 0
                    ? state.content.filter
                        ? state.content.noWorkspaceContentFoundFilteredLabel
                        : state.content.noWorkspaceContentFoundLabel
                    : "",
        },
    }),

    [actions.REQUEST_COVERPAGE_GRID]: (state): ICoverPage => ({
        ...state,
        isLoading: true,
    }),

    [actions.RECEIVE_COVERPAGE_GRID]: (
        state,
        { grid }: actions.ReceiveCoverPageGrid,
    ): ICoverPage => ({
        ...state,
        isLoading: false,
        grid,
    }),

    [actions.UPDATE_TILES_ORDER]: (
        state,
        {
            oldIndex,
            reorderedTileId,
            targetIndex,
            targetTileId,
        }: actions.UpdateTilesOrder,
    ): ICoverPage => {
        const grid = state.grid
        const newTiles = reorderTiles(
            grid.tiles,
            targetIndex,
            oldIndex,
            reorderedTileId,
            targetTileId,
        )
        return {
            ...state,
            grid: {
                ...grid,
                tiles: newTiles,
            },
        }
    },

    [actions.REMOVE_TILE]: (
        state,
        { tileId }: actions.RemoveTile,
    ): ICoverPage => {
        const grid = state.grid
        const newTiles = removeTile(grid.tiles, tileId)

        return {
            ...state,
            grid: {
                ...grid,
                tiles: newTiles,
            },
        }
    },
}

export default function reducer(
    state = initialState,
    action: Action,
): ICoverPage {
    const handler: (state: ICoverPage, action: Action) => ICoverPage =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
